import React, { useState } from "react";

const AddTaxValueModal = ({ onClose }) => {
  const [taxName, setTaxName] = useState("");
  const [taxValue, setTaxValue] = useState("");
  const [defaultAdd, setDefaultAdd] = useState(true);

  return (
    <div className="fixed inset-0 bg-black bg-opacity-40 flex items-center justify-center z-50">
      <div className="bg-white w-full max-w-sm p-6 rounded-xl shadow-xl relative">
        <button
          onClick={onClose}
          className="absolute top-3 right-4 text-red-500 text-xl font-bold"
        >
          ×
        </button>
        <h3 className="text-lg font-semibold mb-4">Add Tax Value</h3>

        <label className="block mb-1">Tax Name (GST / CGST+IGST / VAT)</label>
        <input
          type="text"
          className="input mb-4"
          value={taxName}
          onChange={(e) => setTaxName(e.target.value)}
        />

        <label className="block mb-1">Tax Value in %</label>
        <input
          type="number"
          className="input mb-4"
          value={taxValue}
          onChange={(e) => setTaxValue(e.target.value)}
        />

        <div className="flex items-center mb-4">
          <input
            type="checkbox"
            id="defaultAdd"
            checked={defaultAdd}
            onChange={() => setDefaultAdd(!defaultAdd)}
            className="mr-2"
          />
          <label htmlFor="defaultAdd" className="text-sm text-gray-700">
            Default Add to Receipt
          </label>
        </div>

        <button className="w-full py-2 bg-primary text-white rounded">Save</button>
      </div>
    </div>
  );
};

export default AddTaxValueModal;
